<!--
 * @Author: your name
 * @Date: 2019-11-14 10:11:49
 * @LastEditTime: 2020-05-21 18:18:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fontend_old_pc\src\common\footer.vue
-->
<template>
  <div>
    <div class="controlWdth">
      <div class="foot-top" v-if="this.$route.name !== 'Login'">
        <ul>
          <li>
            <img src="/static/img/pp1.png" />
            <div>
              <h2>品牌供应商</h2>
              <p>厂家直供 品牌保证</p>
            </div>
          </li>
          <li>
            <img src="/static/img/zp1.png" />
            <div>
              <h2>正品保证</h2>
              <p>正品行货 放心选购</p>
            </div>
          </li>
          <li>
            <img src="/static/img/sh1.png" />
            <div>
              <h2>售后无忧</h2>
              <p>30天超长退货期</p>
            </div>
          </li>
          <li>
            <img src="/static/img/by1.png" />
            <div>
              <h2>全场包邮</h2>
              <p>港澳台及个别地区除外</p>
            </div>
          </li>
        </ul>
      </div>
      <ul>
        <li
          style="width: 40%;"
          :style="
            this.$route.name === 'Login'
              ? 'padding-top:12px;'
              : 'padding-top:15px;'
          "
        >
          <div
            class="common_nav_log float-left"
            style="padding-right:15px;border-right: solid 1px #E5E5E5;margin-right:15px; margin-top:12px"
          >
            <router-link to="/">
              <!-- <img :src='logourl' onerror="src='/static/img/logo.png'" style="max-width:200px;max-height:60px;width: auto;" /> -->
              <!-- -webkit-filter: grayscale(100%);filter: grayscale(100%); -->
              <img
                :src="$store.state.webInfo.logo_pc"
                onerror="src='/static/img/logo.png'"
                style="max-width: 200px; max-height: 60px; width: auto;"
              />
            </router-link>
          </div>
          <img
            src="/static/img/f-contact1.png"
            style="width: 60px; height:60px;margin-right:15px; margin-top:10px;cursor: auto;"
            class="float-left"
          />
          <div>
            <span
              style="display:inline-block;font-size: 24px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #262626;line-height: 31px;margin-top:14px; cursor: auto;"
              >{{ $store.state.webInfo.service_tell }}
            </span>
            <p
              style="padding-top:5px;color: #AAAAAA;height: 16px;font-size: 12px;line-height:16px;cursor: auto;"
            >
              {{ $store.state.webInfo.service_tel_remark }}
            </p>
          </div>
        </li>
        <li
          style="float:right; margin-bottom:12px;"
          :style="
            this.$route.name === 'Login'
              ? 'padding-top:12px;'
              : 'padding-top:15px;'
          "
        >
          <p
            style="    min-height: 1px;cursor: auto;width:270px;float:left; font-size: 12px;font-family: MicrosoftYaHei;color: #7A7A7A;line-height: 19px;padding-right:10px;display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden;"
          >
            {{ $store.state.webInfo.copyright }}{{ $store.state.webInfo.icp }}
          </p>
          <div
            style="float:left;padding-left:15px;border-left: solid 1px #E5E5E5;position:relative; "
          >
            <!-- <img src="/static/img/logo.png" style="width:85px; height:84px;"> -->
            <img
              style="width:85px; position:absolute;"
              :src="$store.state.webInfo.wap_url"
              alt
            />
            <canvas
              id="wapcanvas"
              width="85"
              height="85"
              style="width:85px!important"
            ></canvas>
            <p
              style="text-align:center; height: 16px;font-size: 12px;font-family: MicrosoftYaHei;color: #AAAAAA;line-height: 16px;margin-top:2px;"
            >
              WAP端积分商城
            </p>
          </div>
        </li>
        <!-- <li
        style="width: 48%;border-left: 1px solid #EFEFEF;padding-left:80px;border-right: 1px solid #EFEFEF;"
      >
        <img
          style="width:99px;"
          :src="$store.state.webInfo.logo_pc"
          onerror="src='/static/img/logo.png'"
          alt
        />
        <p
          style="padding-top:18px;font-size:12px;color:#3C3C3C;opacity:0.5;"
        >{{$store.state.webInfo.copyright}}{{$store.state.webInfo.icp}}</p>
      </li> -->
        <!-- <li style="width: 25%;padding-top:0px">
          <img style="width:85px;padding:5px" :src="$store.state.webInfo.wap_url" alt />
        <canvas id="wapcanvas" width="85" height="85" style="width:85px!important"></canvas>
        <p class="left_txt">手机积分商城</p>
      </li> -->
        <div class="clear"></div>
      </ul>
    </div>
    <div class="foot-bottom" v-if="this.$route.name !== 'Login'">
      <div
        style="width:1200px; position:relative;margin:0 auto;display: flex;flex;height:17px;
    justify-content: center;"
      >
        <p>
          重庆百礼汇科技有限公司版权所有&nbsp;&nbsp;&nbsp;&nbsp;Copyright©2007-2015
          All Rights Reserved&nbsp;&nbsp;|&nbsp;&nbsp;渝ICP备11000342号-1
        </p>
        &nbsp;&nbsp; &nbsp;&nbsp; <a href="#">渝公网安备 50010502001624号</a>
      </div>
    </div>
    <div class="foot-bottom1" v-else>
      <div
        style="width:1200px; position:relative;margin:0 auto;display: flex;height:17px;
    justify-content: left; color:#aaa;"
      >
        <p>
          重庆百礼汇科技有限公司版权所有&nbsp;&nbsp;&nbsp;&nbsp;Copyright©2007-2015
          All Rights Reserved&nbsp;&nbsp;|&nbsp;&nbsp;渝ICP备11000342号-1
        </p>
        &nbsp;&nbsp; &nbsp;&nbsp; <a href="#">渝公网安备 50010502001624号</a>
      </div>
    </div>
  </div>
</template>
<script>
var QRCode = require("qrcode");
export default {
  methods: {},
  created() {
    setTimeout(() => {
      let str = this.$store.state.webInfo.wap_url.split("php?text=");
      var canvas = document.getElementById("wapcanvas");
      QRCode.toCanvas(canvas, str[str.length - 1], function(error) {
        if (error) console.error(error);
        console.log("success!");
      });
    }, 300);
  }
};
</script>
<style lang="less" scoped>
.foot-bottom {
  background: rgba(0, 0, 0, 0.7);
  padding: 9px 0px 8px 0px;
  p {
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
  a {
    color: #fff;
  }
}
.foot-bottom1 {
  padding-bottom: 20px;
  p {
    color: #aaa;
    font-size: 12px;
  }
  a {
    color: #aaa;
    font-size: 12px;
  }
}
.controlWdth {
  // box-shadow: 0px 2px 5px #e0dede;
  // height: 170px;
  .foot-top {
    margin-top: 20px;
    padding-bottom: 19px;
    border-bottom: solid 1px #e5e5e5;
    ul {
      display: flex;
      justify-content: space-between;
    }
    ul li {
      padding: 0px;
      margin: 0px;
      height: auto;
      display: flex;
      cursor: auto;
      img {
        width: 72px;
        margin-right: 15px;
        height: 72px;
      }
      h2 {
        font-size: 15px;
        font-family: MicrosoftYaHei;
        color: #262626;
        line-height: 20px;
        padding-top: 7px;
        padding-bottom: 3px;
      }
      p {
        height: 21px;
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #aaaaaa;
        line-height: 21px;
      }
    }
  }
  ul {
    // overflow: hidden;
    li {
      float: left;
      text-align: left;
      box-sizing: border-box;

      // margin-top:15px;
    }
  }
  .left_txt {
    font-size: 11px;
    width: 86px;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(118, 118, 118, 1);
    padding-left: 5px;
  }
  #wapcanvas {
    width: 85px !important;
    height: 85px !important;
    padding: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/footer.vue